import { ApiError, QueryKeys, Role } from '@connect-x-app/shared-domain-models';
import { getRole } from '@connect-x-app/web-data-access';
import { useQuery } from '@tanstack/react-query';

export const useGetRole = (roleId: string) =>
  useQuery<Role, ApiError>({ queryFn: () => getRole(roleId), queryKey: [QueryKeys.ROLE, roleId] });
